import React, { forwardRef, useCallback } from 'react'
import { Scrollbars } from 'react-custom-scrollbars'
import styled from 'styled-components'

const ScrollThumb = styled.div`
  background-color: ${props => props.theme.global.colors.scrollThumb};
  border-radius: 3px;
  width: 5px !important;
  margin-left: auto;
`

// const ScrollTrack = styled.div`
//   width: 3px;
// `

const CustomScrollbarsType = ({ onScroll, forwardedRef, style, children }) => {
  const refSetter = useCallback(scrollbarsRef => {
    if (scrollbarsRef) {
      forwardedRef(scrollbarsRef.view)
    } else {
      forwardedRef(null)
    }
  }, [])

  return (
    <Scrollbars
      ref={refSetter}
      style={{ ...style, overflow: 'hidden' }}
      onScroll={onScroll}
      renderThumbVertical={props => <ScrollThumb {...props} />}
    >
      {children}
    </Scrollbars>
  )
}

export const CustomScrollbars = forwardRef((props, ref) => (
  <CustomScrollbarsType {...props} forwardedRef={ref} />
))
